module.exports = __webpack_public_path__ + "img/lens-160-plus-01.6bd47a55.png";